import * as Yup from "yup";
import form from "./form";

const {
    formField: { hours, is_free, is_late_night, players },
} = form;

const validations = Yup.object().shape({
    [hours.name]: Yup.number()
        .min(0, hours.invalidMsg) // Must be a non-negative number
        .required(hours.errorMsg), // Required field
    [is_free.name]: Yup.boolean(), // Boolean, no specific validation needed
    [is_late_night.name]: Yup.boolean(), // Boolean, no specific validation needed
    [players.name]: Yup.array()
        .of(Yup.number()) // Array of player IDs (numbers)
        .min(1, players.errorMsg), // At least one player must be selected
});

export default validations;
